import React from 'react'
import Skeleton from 'react-loading-skeleton'

function RecommendedTopicSkeleton() {
    return (
        <a href={`/cateogary/`} className="topics-list mt-3">
            <div className="list1">
                <span className="fa fa-bath" />
                <Skeleton style={{ marginLeft: `1.2em` }} width={`15em`} height={`1.5em`} />
            </div>
        </a>
    )
}

export default RecommendedTopicSkeleton
